import { getHeaderBars } from "@/api/menu";


const global = {
  state: {
    menuType: true,
    pageNames: ['Home'],
    nowPageValue: 'Home',
    closePageNames: '',
    requestType: true,
    company: {},
    stationCut: [],
    department: [],
    sysTypeAll: {},
    // 用于设置菜单展开和缩小时的宽度变化差额，用于展示内容根据宽度变化自动调整自身宽度
    menuWidth: 0,
  },
  mutations: {
    //当前菜单状态，true为正常，false为缩小
    SET_MENU_TYPE: (state, menuType) => {
      state.menuType = menuType
      if(menuType){
        state.menuWidth = 0
      }else{
        state.menuWidth = 155
      }
    },
    //设置当前激活的标签页
    SET_PAGE_NAME: (state, nowPageValue) => {
      if(nowPageValue != '' && state.pageNames.length<99){
        if(state.pageNames.indexOf(nowPageValue)==-1){
          state.pageNames.push(nowPageValue)
        }
        state.nowPageValue = nowPageValue
      }
    },
    //关闭当前打开标签
    DEL_PAGE_NAME: (state, nowPageIndex) => {
      state.closePageNames = state.pageNames[nowPageIndex]
      state.pageNames.splice(nowPageIndex,1)
      state.nowPageValue = state.pageNames[nowPageIndex-1]
    },
    //关闭所有打开标签
    DEL_PAGE_ALL: (state) => {
      state.pageNames.splice(1,99)
      state.nowPageValue = 'Home'
    },
    //设置是否允许继续请求其他
    SET_REQUEST_TYPE: (state, requestType) => {
      state.requestType = requestType
    },
    //设置企业信息
    SET_COMPANY: (state, company) => {
      state.company = company
    },
    //设置可切换站点信息
    SET_STATION_CUT: (state, stationCut) => {
      state.stationCut = stationCut
    },
    // 设置部门信息
    SET_DEPARTMENT: (state, department) => {
      state.department = department
    },
    // 设置所有对照信息用于下拉菜单使用
    SET_SYS_TYPE_ALL: (state, sysTypeAll) => {
      state.sysTypeAll = sysTypeAll
    }
  },
  actions: {
    // 获取HeaderBar组件所有相关信息，包含user、company、station
    getHeaderBars({ commit }) {
      getHeaderBars().then(res => {
        const code = res.status.code       
        if(code == 200){
          const company = res.data.company
          commit('SET_COMPANY', company)
          const stationCut = res.data.stationcut
          commit('SET_STATION_CUT', stationCut)
          const user = res.data.user
          commit('SET_USER', user)
          const department = res.data.department
          commit('SET_DEPARTMENT', department)
          const sysTypeAll = res.data.systypeall
          var sysTypeAlls = {}
          for(var key in sysTypeAll){
            sysTypeAlls[sysTypeAll[key].typeType] = sysTypeAll[key]            
          }
          commit('SET_SYS_TYPE_ALL', sysTypeAlls)
        }        
      }).catch(error => {
        reject(error)
      })
    }
  }
}


export default global



// WEBPACK FOOTER //
// ./src/store/modules/global.js